import React, {useContext} from 'react';
import {BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

/* Pages */
import Header from './pages/Header';
import Footer from './pages/Footer';
import Login from './pages/Login';
import Trip from './pages/Trip';
import Rates from './pages/Rates';
import Rate from './pages/Rate';
import Stops from './pages/Stops';
import Stop from './pages/Stop';
import Month from './pages/Month';
import User from './pages/User';
import UserDeleted from './pages/UserDeleted';
import Journey from './pages/Journey';
import Users from './pages/Users';
import Rutas from './pages/Rutas';
import Ruta from './pages/Ruta';
import Payments from './pages/Payments';
import Invoices from './pages/Invoices';
import Invoice from './pages/Invoice';
import Payment from './pages/Payment';
import Configuration from './pages/Configuration';
import DriverPayments from './pages/DriverPayments';
import Discrecionals from './pages/Discrecionals';
import Discrecional from './pages/Discrecional';
import Customers from './pages/Customers';
import Customer from './pages/Customer';
import Calendar from './pages/Calendar';

import {AppContext, AppProvider} from './AppContext';

// Notifications
import 'react-notifications/lib/notifications.css';
import {NotificationContainer} from 'react-notifications';

function App() {
    return (
        <AppProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
            <NotificationContainer/>
        </AppProvider>
    );
}

function AppContent() {
    const context = useContext(AppContext);
    const isLoggedIn = context && context.user && context.user.id;

    if (!isLoggedIn) {
        // Login page - no header/footer
        return (
            <Routes>
                <Route path='/login' element={<Login />} />
                <Route path='*' element={<Navigate to="/login" />} />
            </Routes>
        );
    }

    // Logged in - show header/footer
    return (
        <div className="d-flex flex-column min-vh-100">
            <Header/>
            <main className="flex-grow-1" style={{ paddingTop: '72px' }}>
                <Routes>
                    <Route path='/*' element={<AppRoutersTrebus/>}/>
                </Routes>
            </main>
            <Footer/>
        </div>
    );
}

function AppRoutersTrebus() {
    const context = useContext(AppContext);

    return (
        <Routes>
            <Route path='/journey' element={<Journey />} />
            <Route path='/calendar' element={<Calendar />} />
            <Route path='/users' element={<Users />} />
            <Route path='/user/:id' element={<User />} />
            <Route path='/user/:id/deleted' element={<UserDeleted />} />
            <Route path='/rates' element={<Rates />} />
            <Route path='/rates/create' element={<Rate creating={true} />} />
            <Route path='/rates/:id' element={<Rate />} />
            <Route path='/routes' element={<Rutas />} />
            <Route path='/routes/create' element={<Ruta creating={true} />} />
            <Route path='/route/:id' element={<Ruta />} />
            <Route path='/stops' element={<Stops />} />
            <Route path='/stops/create' element={<Stop creating={true} />} />
            <Route path='/stops/:id' element={<Stop />} />
            <Route path='/trip/:id' element={<Trip />} />
            <Route path='/payments' element={<Payments />} />
            <Route path='/driver-payments' element={<DriverPayments />} />
            <Route path='/month' element={<Month />} />
            <Route path='/payment/:id' element={<Payment />} />
            <Route path='/conf' element={<Configuration />} />
            <Route path='/discrecionals' element={<Discrecionals />} />
            <Route path='/discrecional/:id' element={<Discrecional />} />
            <Route path='/invoices' element={<Invoices />} />
            <Route path='/invoice/:id' element={<Invoice />} />
            <Route path='/customers' element={<Customers />} />
            <Route path='/customer/:id' element={<Customer />} />

            {/* Redirect any unknown route to the main page based on user role */}
            {context.user.role === 'USER' ? (
                <Route path='*' element={<Navigate to="/calendar" replace />} />
            ) : (
                <Route path='*' element={<Navigate to="/journey" replace />} />
            )}
        </Routes>
    );
}

export default App;
